const ww = window.innerWidth
const wh = window.innerHeight

export default {
  s1: {
    s1_bg: {
      size: { mode: 'cover' },
      position: 'center',
      anchor: 'center'
    },
    s1_text: {
      size: { mode: 'widthFit', width: 314 / 640 },
      position: { x: 0.9, y: 0.11 },
      anchor: 'topRight'
    },
    // s1_trash1: {
    //   size: { mode: 'heightFit', height: 0.05 },
    //   position: { x: 0.2, y: 0.8 },
    //   anchor: 'center'
    // },
    // s1_trash2: {
    //   size: { mode: 'heightFit', height: 0.04 },
    //   position: { x: 0.7, y: 0.9 },
    //   anchor: 'center'
    // },
    s1_rect: {
      size: { mode: 'heightFit', height: 0.29 },
      position: { x: 0.08, y: 0.84 },
      anchor: 'bottomLeft'
    },
    s1_chat1: {
      size: { mode: 'heightFit', height: 0.03 },
      position: { x: 0.095, y: 0.66 },
      anchor: 'bottomLeft'
    },
    s1_chat2: {
      size: { mode: 'heightFit', height: 0.05 },
      position: { x: 0.095, y: 0.725 },
      anchor: 'bottomLeft'
    },
    s1_chat3: {
      size: { mode: 'heightFit', height: 0.05 },
      position: { x: 0.095, y: 0.79 },
      anchor: 'bottomLeft'
    },
  },
  s2: {
    s2_bg: {
      size: { mode: 'cover' },
      position: 'top',
      anchor: 'top'
    },
    s2_text: {
      size: { mode: 'widthFit', width: 376 / 640 },
      position: { x: 0.97, y: 0.08 },
      anchor: 'topRight'
    },
    s2_light: {
      size: { mode: 'widthFit', width: 1 },
      position: { x: -0.001, y: 1.5 * ww / wh },
      anchor: 'bottomLeft'
    },
    s2_rect: {
      size: { mode: 'widthFit', width: 0.49 },
      position: { x: 0.036, y: 0.59 * ww / wh },
      anchor: 'topLeft'
    },
    s2_chat1: {
      size: { mode: 'widthFit', width: 0.406 },
      position: { x: 0.049, y: 0.67 * ww / wh },
      anchor: 'topLeft'
    },
    s2_chat2: {
      size: { mode: 'widthFit', width: 0.325 },
      position: { x: 0.049, y: 0.77 * ww / wh },
      anchor: 'topLeft'
    },
    s2_chat3v2: {
      size: { mode: 'widthFit', width: 0.236 },
      position: { x: 0.275, y: 0.97 * ww / wh },
      anchor: 'topLeft'
    },
  },
  s3: {
    s3_bgv3: {
      size: { mode: 'cover' },
      position: 'top',
      anchor: 'top'
    },
    s3_text: {
      size: { mode: 'widthFit', width: 350 / 640 },
      position: { x: 0.5, y: 0.07 },
      anchor: 'top'
    },
    s3_hand: {
      size: { mode: 'widthFit', width: 293 / 640 },
      position: { x: 436 / 640, y: 545 / 640 * ww / wh },
      anchor: { x: 0.9147, y: 0.1875 }
    },
    s3_light: {
      size: { mode: 'widthFit', width: 392 / 640 },
      position: { x: 0.112, y: 0.62 * ww / wh },
      anchor: 'topLeft'
    },
    s3_chat: {
      size: { mode: 'widthFit', width: 0.32 },
      position: { x: 0.98, y: 0.5 * ww / wh },
      anchor: 'topRight'
    },
    s3_tag: {
      size: { mode: 'widthFit', width: 84 / 640 },
      position: { x: 0.352, y: 1.345 * ww / wh },
      anchor: 'bottom'
    },
  }
}
